import * as React from 'react';

import classnames from 'classnames';

import styles from './slack-message-preview.module.css';

type Props = {
    formKey: string;
};

export function SlackMessagePreviewContentLead(props: Props) {
    return (
        <div className={styles['preview-card-lead']}>
            <div
                className={classnames(styles['accent-bar'], styles[getAccentColor(props.formKey)])}
            />
            <div className={styles['preview-card-lead-info']}>
                <h4>Dunder Mifflin</h4>
                <div className={styles['preview-card-attributes']}>
                    <div>
                        <h5>Assignee</h5>
                        Otto Mation
                    </div>
                    <div>
                        <h5>Value</h5>
                        $350.00
                        <br />
                        Sticky squares and 2 other products
                    </div>
                </div>
            </div>
        </div>
    );
}

function getAccentColor(formKey: string) {
    switch (formKey) {
        case 'LEAD_WON':
            return 'accent-bar-won';
        case 'LEAD_LOST':
            return 'accent-bar-lost';
        case 'LEAD_CANCELLED':
            return 'accent-bar-cancelled';
        default:
            return 'accent-bar-open';
    }
}
